"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _checkbox = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/checkbox"));

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CheckboxField = function CheckboxField(_ref) {
  var error = _ref.error,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      testid = _ref.testid,
      value = _ref.value,
      touched = _ref.touched;
  return (
    /*#__PURE__*/
    _react.default.createElement("div", {
      className: "form_checkboxWrapper"
    },
    /*#__PURE__*/
    _react.default.createElement(_formik.Field, {
      name: name
    }, function () {
      return (
        /*#__PURE__*/
        _react.default.createElement(_checkbox.default, {
          onChange: onChange,
          label:
          /*#__PURE__*/
          _react.default.createElement(_react.default.Fragment, null, label, ' ', error && touched ?
          /*#__PURE__*/
          _react.default.createElement(_styledText.default, {
            className: "form_checkboxError"
          }, error) : ''),
          testid: testid,
          checked: value,
          error: error
        })
      );
    }))
  );
};

var _default = CheckboxField;
exports.default = _default;